import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, Subject, timer } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export let BASE_URL;
 
const browserWindow = window || {};
const browserWindowEnv = browserWindow["__env"] || {};

BASE_URL = browserWindowEnv.BASE_URL;


@Injectable({
  providedIn: 'root'
})

export class DynamicApicallService {
  private loaderSubject = new Subject<boolean>();
  loaderState$ = this.loaderSubject.asObservable();

  constructor(private http: HttpClient) { }

  //   private makeApiCall(
  //     endpoint: string,
  //     requestType: 'GET' | 'POST' | 'PUT' | 'DELETE',
  //     opts: {
  //       params?: { [key: string]: any };
  //       headers?: { [key: string]: string };
  //       body?: any;
  //     } = {}
  //   ): Observable<any> {
  //     const url = `${BASE_URL}${endpoint}`;

  //     let httpParams = new HttpParams();
  //     if (opts.params) {
  //       for (const key in opts.params) {
  //         if (opts.params.hasOwnProperty(key)) {
  //           httpParams = httpParams.set(key, opts.params[key]);
  //         }
  //       }
  //     }

  //     const headers = new HttpHeaders(opts.headers || {});

  //     switch (requestType) {
  //       case 'GET':
  //         return this.http.get(url, { params: httpParams, headers });
  //       case 'POST':
  //         return this.http.post(url, opts.body || {}, { params: httpParams, headers });
  //       case 'PUT':
  //         return this.http.put(url, opts.body || {}, { params: httpParams, headers });
  //       case 'DELETE':
  //         return this.http.delete(url, { params: httpParams, headers });
  //       default:
  //         throw new Error(`Unsupported request type: ${requestType}`);
  //     }
  //   }

  //   // ********** GET **********
  //   // this.apiCall.callApi('Contractor/GetContractorsFilter', 'GET', {params}).subscribe((response) => { }

  //   // ********** POST **********
  //   // this.apiCall.callApi('Common/List/CLPMS_DamageNLose_Listing', 'POST', { body: reqObj}).subscribe((response) => { }

  //   callApi(endpoint: string, requestType: 'GET' | 'POST' | 'PUT' | 'DELETE', opts: { params?: { [key: string]: any }; headers?: { [key: string]: string }; body?: any } = {}): Observable<any> {
  //     return this.makeApiCall(endpoint, requestType, opts).pipe(
  //       catchError((error) => {
  //         console.error('API call failed:', error);
  //         return throwError(error);
  //       })
  //     );
  //   }

  private makeApiCall(
    endpoint: string,
    requestType: 'GET' | 'POST' | 'PUT' | 'DELETE',
    opts: {
      params?: { [key: string]: any };
      headers?: { [key: string]: string };
      body?: any;
      showLoader?: boolean;
    } = {}
  ): Observable<any> {
    const url = `${BASE_URL}${endpoint}`;

    let httpParams = new HttpParams();
    if (opts.params) {
      for (const key in opts.params) {
        if (opts.params.hasOwnProperty(key)) {
          httpParams = httpParams.set(key, opts.params[key]);
        }
      }
    }

    const headers = new HttpHeaders(opts.headers || {});
    const showLoader = opts.hasOwnProperty('showLoader') ? opts.showLoader : true;

    if (showLoader) {
      this.loaderSubject.next(true);
    }

    const loaderTimeout$ = timer(120000);

    let apiCall$: Observable<any>;
    switch (requestType) {
      case 'GET':
        apiCall$ = this.http.get(url, { params: httpParams, headers });
        break;
      case 'POST':
        apiCall$ = this.http.post(url, opts.body || {}, { params: httpParams, headers });
        break;
      case 'PUT':
        apiCall$ = this.http.put(url, opts.body || {}, { params: httpParams, headers });
        break;
      case 'DELETE':
        apiCall$ = this.http.delete(url, { params: httpParams, headers });
        break;
      default:
        throw new Error(`Unsupported request type: ${requestType}`);
    }

    const apiObservable$ = apiCall$.pipe(
      catchError((error) => {
        console.error('API call failed:', error);
        return throwError(error);
      }),
      finalize(() => {
        if (showLoader) {
          this.loaderSubject.next(false);
        }
      })
    );

    return new Observable((subscriber) => {
      const apiSubscription = apiObservable$.pipe(takeUntil(loaderTimeout$)).subscribe({
        next: (response) => {
          if (response === true && showLoader) {
            this.loaderSubject.next(false);
          }
          subscriber.next(response);
        },
        error: (err) => {
          subscriber.error(err);
        },
        complete: () => {
          subscriber.complete();
        },
      });

      const timeoutSubscription = loaderTimeout$.subscribe(() => {
        if (showLoader) {
          this.loaderSubject.next(false);
        }
        timeoutSubscription.unsubscribe();
      });

      return () => {
        apiSubscription.unsubscribe();
        timeoutSubscription.unsubscribe();
      };
    });
  }

  callApi(
    endpoint: string,
    requestType: 'GET' | 'POST' | 'PUT' | 'DELETE',
    opts: {
      params?: { [key: string]: any };
      headers?: { [key: string]: string };
      body?: any;
      showLoader?: boolean;
    } = {}
  ): Observable<any> {
    const { showLoader = true, ...restOpts } = opts;
    return this.makeApiCall(endpoint, requestType, { ...restOpts, showLoader });
  }  

}